export const loginWithTwitter = async config => {
  let data = null;
  let error = null;

  const popup = window.open(
    `https://api.twitter.com/oauth/authenticate?oauth_token=${config.token}`,
    "",
    "width=800,height=600"
  );
  if (!popup) {
    error = new Error("Popup blocked by browser.");
  }
  const handleOauthEvent = event => {
    if (event.data.type === "oauth" && event.data.provider === "twitter") {
      if (event.data.error) {
        error = new Error(event.data.error);
      } else if (event.data.token) {
        data = {
          token: event.data.token,
          verifier: event.data.verifier,
        };
      }
    }
  };
  window.addEventListener("message", handleOauthEvent);
  return new Promise((resolve, reject) => {
    let id = setInterval(() => {
      if (!data && popup && popup.closed) {
        reject(new Error("Popup has been closed."));
      }
      if (data || error) {
        clearInterval(id);
        popup && popup.close();
        error && !data && reject(error);
        data && !error && resolve(data);
      }
    }, 100);
  });
};
